import { makeStyles } from 'tss-react/mui';

export const PRODUCT_CARDS_MARKUP_FONT_SIZE = 12;

export const useProductCardsPriceStyles = makeStyles()((theme) => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(0.5),
  },
  retail: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  markup: {
    '&.MuiChip-sizeSmall > .MuiChip-label, &.MuiChip-sizeSmall > .MuiChip-icon': {
      color: theme.palette.text.secondary,
    },
  },
}));
